(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const dayMs = 86400000;
  function parseSchedule(config) {
    if (!config.enabled || config.country !== 'CA' || !/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(config.cutoff)) return null;
    if (!config.timeZone || !Number.isInteger(config.transitDays) || config.transitDays < 1 || config.transitDays > 10) return null;
    try {
      const clock = new Intl.DateTimeFormat('en-CA', { timeZone: config.timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      const closed = new Set(String(config.closedDates || '').split(/[\s,]+/).filter(Boolean));
      for (const date of closed) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
        const parsed = new Date(`${date}T00:00:00Z`);
        if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) return null;
      }
      const [hour, minute] = config.cutoff.split(':').map(Number);
      return { clock, closed, cutoffSeconds: (hour * 60 + minute) * 60, transitDays: config.transitDays };
    } catch (_) { return null; }
  }
  function deliveryState(schedule, now) {
    const parts = Object.fromEntries(schedule.clock.formatToParts(now).map(part => [part.type, part.value]));
    const today = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    const seconds = Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second);
    const businessDay = (stamp) => {
      const date = new Date(stamp);
      return date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !schedule.closed.has(date.toISOString().slice(0, 10));
    };
    const nextBusinessDay = (stamp) => {
      for (let i = 0; i < 366; i++, stamp += dayMs) if (businessDay(stamp)) return stamp;
      return null;
    };
    const sameDay = businessDay(today) && seconds < schedule.cutoffSeconds;
    const dispatch = sameDay ? today : nextBusinessDay(today + dayMs);
    if (dispatch === null) return null;
    let arrival = dispatch;
    for (let day = 0; day < schedule.transitDays; day++) {
      arrival = nextBusinessDay(arrival + dayMs);
      if (arrival === null) return null;
    }
    const cutoffWallTime = dispatch + schedule.cutoffSeconds * 1000;
    let cutoff = now.getTime() + dispatch - today + (schedule.cutoffSeconds - seconds) * 1000 - now.getUTCMilliseconds();
    for (let attempt = 0; attempt < 4; attempt++) {
      const wall = Object.fromEntries(schedule.clock.formatToParts(new Date(cutoff)).map(part => [part.type, part.value]));
      const wallTime = Date.UTC(Number(wall.year), Number(wall.month) - 1, Number(wall.day), Number(wall.hour), Number(wall.minute), Number(wall.second));
      if (wallTime === cutoffWallTime) {
        const remainingSeconds = Math.max(0, Math.ceil((cutoff - now.getTime()) / 1000));
        return { arrival, dispatch, sameDay, cutoff, remainingSeconds, remaining: Math.ceil(remainingSeconds / 60) };
      }
      cutoff += cutoffWallTime - wallTime;
    }
    return null;
  }
  function initEstimate(panel) {
    if (panel.disposeEstimate) return;
    let config;
    try { config = JSON.parse(panel.querySelector('[data-delivery-config]').textContent); } catch (_) { return; }
    const schedule = parseSchedule(config);
    const arrival = panel.querySelector('[data-delivery-arrival]');
    const dispatch = panel.querySelector('[data-delivery-dispatch]');
    const countdown = panel.querySelector('[data-delivery-timer]');
    const note = panel.querySelector('[data-delivery-note]');
    const labels = config.labels;
    let timer;
    let dateFormat;
    try { dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en-CA', { timeZone: 'UTC', month: 'short', day: 'numeric' }); }
    catch (_) { dateFormat = new Intl.DateTimeFormat('en-CA', { timeZone: 'UTC', month: 'short', day: 'numeric' }); }
    const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
    const refresh = () => {
      window.clearTimeout(timer);
      if (document.hidden || panel.hidden) return;
      const state = schedule ? deliveryState(schedule, new Date()) : null;
      panel.dataset.deliveryState = state ? (state.sameDay ? 'before-cutoff' : 'next-dispatch') : 'checkout';
      if (!state) {
        setText(arrival, labels.fallback);
        setText(note, labels.service);
        panel.title = labels.service;
        dispatch.hidden = true;
        return;
      }
      setText(arrival, dateFormat.format(state.arrival));
      setText(note, labels.note);
      panel.title = labels.note;
      const hours = Math.floor(state.remainingSeconds / 3600);
      const minutes = Math.floor(state.remainingSeconds / 60) % 60;
      const seconds = state.remainingSeconds % 60;
      setText(countdown, [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':'));
      countdown.setAttribute('datetime', `PT${hours}H${minutes}M${seconds}S`);
      dispatch.hidden = false;
      timer = window.setTimeout(refresh, Math.max(100, 1000 - Date.now() % 1000));
    };
    const observer = new MutationObserver(refresh);
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('pageshow', refresh);
    panel.disposeEstimate = () => {
      window.clearTimeout(timer);
      observer.disconnect();
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('pageshow', refresh);
      delete panel.disposeEstimate;
    };
    refresh();
  }
  const init = () => document.querySelectorAll('[data-delivery-estimate]').forEach(initEstimate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-delivery-estimate]').forEach(panel => panel.disposeEstimate?.()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const initGallery = gallery => {
    if (gallery.disposeGallery) return;
    const thumbs = [...gallery.querySelectorAll('[data-media-thumb]')];
    const slides = [...gallery.querySelectorAll('[data-media-slide]')];
    const rail = gallery.querySelector('[data-gallery-thumbnails]');
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (!thumbs.length || !rail || !previous || !next) return;
    let selected = Math.max(0, thumbs.findIndex(thumb => thumb.classList.contains('is-active')));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const select = (index, focus = false) => {
      selected = Math.max(0, Math.min(thumbs.length - 1, index));
      const thumb = thumbs[selected];
      slides.forEach(slide => {
        const active = slide.dataset.mediaSlide === thumb.dataset.mediaThumb;
        if (!active && !slide.hidden) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
          slide.querySelectorAll('model-viewer').forEach(model => model.pause?.());
        }
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      thumbs.forEach((item, i) => {
        item.classList.toggle('is-active', i === selected);
        item.setAttribute('aria-current', String(i === selected));
      });
      previous.disabled = selected === 0;
      next.disabled = selected === thumbs.length - 1;
      if (focus) thumb.focus({ preventScroll: true });
      const bounds = rail.getBoundingClientRect();
      const item = thumb.getBoundingClientRect();
      const offset = item.left < bounds.left + 4 ? item.left - bounds.left - 4 : item.right > bounds.right - 4 ? item.right - bounds.right + 4 : 0;
      if (offset) rail.scrollBy({ left: offset, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    const click = event => {
      const thumb = event.target.closest('[data-media-thumb]');
      if (thumb && thumbs.includes(thumb)) select(thumbs.indexOf(thumb));
      else if (event.target.closest('[data-gallery-previous]') && !previous.disabled) select(selected - 1);
      else if (event.target.closest('[data-gallery-next]') && !next.disabled) select(selected + 1);
    };
    const keydown = event => {
      const thumb = event.target.closest('[data-media-thumb]');
      if (!thumb || !thumbs.includes(thumb)) return;
      const rtl = document.documentElement.dir === 'rtl';
      let index = thumbs.indexOf(thumb);
      if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
      else if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = thumbs.length - 1;
      else return;
      event.preventDefault();
      select(index, true);
    };
    gallery.addEventListener('click', click);
    gallery.addEventListener('keydown', keydown);
    previous.hidden = next.hidden = false;
    previous.disabled = selected === 0;
    next.disabled = selected === thumbs.length - 1;
    gallery.classList.add('product-gallery--enhanced');
    gallery.disposeGallery = () => {
      gallery.removeEventListener('click', click);
      gallery.removeEventListener('keydown', keydown);
      previous.hidden = next.hidden = true;
      gallery.classList.remove('product-gallery--enhanced');
      delete gallery.disposeGallery;
    };
  };
  const init = () => document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-gallery]').forEach(gallery => gallery.disposeGallery?.()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["responsive-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const compact = window.matchMedia('(max-width: 989px)');
  const targets = [
    '#product-route-focus', '#product-answer-hub', '#product-parts-support',
    '#product-proof', '#product-fit-guide', '#product-compare', '#product-field-guide',
    '.product-info__spec-details', '.product-trust--conversion',
    '#collection-model-comparison', '#collection-guide', '#collection-contact',
    '.cinematic-home > .field', '.cinematic-home > .machine',
    '.cinematic-home > .performance', '.cinematic-home > .quick-add',
    '.cinematic-home > .compare', '.cinematic-home > .notes',
    '.site-footer__links > div'
  ].join(',');
  const states = new Map();
  const labelSelector = 'h2, .product-trust__heading strong, .label';
  const wrap = host => {
    if (states.has(host)) return;
    const heading = host.querySelector(labelSelector);
    if (!heading) return;
    const disclosure = document.createElement('details');
    disclosure.className = 'responsive-disclosure';
    const summary = document.createElement('summary');
    const title = document.createElement(heading.tagName === 'H2' ? 'h2' : 'span');
    // Preserve word boundaries at editorial <br> breaks without copying IDs or links.
    const label = heading.cloneNode(true);
    label.querySelectorAll('br').forEach(br => br.replaceWith(document.createTextNode(' ')));
    title.textContent = label.textContent.replace(/\s+/g, ' ').trim();
    summary.append(title);
    const content = document.createElement('div');
    content.className = 'responsive-disclosure-content';
    while (host.firstChild) content.append(host.firstChild);
    disclosure.append(summary, content);
    host.append(disclosure);
    host.classList.add('responsive-disclosure-host');
    heading.classList.add('responsive-source-heading');
    const headingAriaHidden = heading.getAttribute('aria-hidden');
    heading.setAttribute('aria-hidden', 'true');
    states.set(host, { disclosure, content, heading, summary, headingAriaHidden });
  };
  const unwrap = host => {
    const state = states.get(host);
    if (!state) return;
    const focusWasSummary = state.summary.contains(document.activeElement);
    while (state.content.firstChild) host.insertBefore(state.content.firstChild, state.disclosure);
    state.disclosure.remove();
    host.classList.remove('responsive-disclosure-host');
    state.heading.classList.remove('responsive-source-heading');
    if (state.headingAriaHidden === null) state.heading.removeAttribute('aria-hidden');
    else state.heading.setAttribute('aria-hidden', state.headingAriaHidden);
    states.delete(host);
    if (focusWasSummary) {
      state.heading.setAttribute('tabindex', '-1');
      state.heading.focus({ preventScroll: true });
    }
  };
  const revealTarget = hash => {
    if (!hash || hash === '#') return null;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return null; }
    const target = document.getElementById(id);
    if (!target) return null;
    states.forEach(({ disclosure }, host) => {
      if (host === target || host.contains(target)) disclosure.open = true;
    });
    let ancestor = target.closest('details');
    while (ancestor) { ancestor.open = true; ancestor = ancestor.parentElement?.closest('details'); }
    return target;
  };
  const followHash = () => {
    const target = revealTarget(window.location.hash);
    if (target) requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
  };
  const sync = () => {
    states.forEach((state, host) => { if (!host.isConnected || !compact.matches) unwrap(host); });
    if (compact.matches) document.querySelectorAll(targets).forEach(wrap);
    revealTarget(window.location.hash);
  };
  const init = () => { sync(); if (window.location.hash) followHash(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  compact.addEventListener('change', sync);
  // Capture before the existing navigation's smooth-scroll handler calculates position.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search) revealTarget(url.hash);
  }, true);
  window.addEventListener('hashchange', followHash);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, host) => { if (event.target === host || event.target.contains(host)) unwrap(host); });
  });
  const printOpen = new Map();
  window.addEventListener('beforeprint', () => states.forEach(({ disclosure }) => {
    printOpen.set(disclosure, disclosure.open); disclosure.open = true;
  }));
  window.addEventListener('afterprint', () => {
    printOpen.forEach((open, disclosure) => { disclosure.open = open; }); printOpen.clear();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
